import { useMemo } from "react";
import { useKeyboardShortcuts } from "../core/useKeyboardShortcuts";
import { ShortcutMap } from "../core/types";

interface UseDeleteShortcutProps {
  onDelete: () => void;
}

export const useDeleteShortcut = ({ onDelete }: UseDeleteShortcutProps) => {
  const shortcuts: ShortcutMap = useMemo(
    () => ({
      backspace: {
        handler: onDelete,
        description: "Delete selected element",
      },
    }),
    [onDelete],
  );

  useKeyboardShortcuts({ shortcuts });
};
